var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"tag":"form","title":_vm.title}},[_vm._t("default"),_c('template',{slot:"footer"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }